export type VehicleCatalogueMakeItem = {
  value: string;
  label: string;
  shortLabel?: string;
  isCustom?: boolean;
};
